import { render, staticRenderFns } from "./EditItemDialogImage.vue?vue&type=template&id=4a07c2d6"
import script from "./EditItemDialogImage.vue?vue&type=script&lang=js"
export * from "./EditItemDialogImage.vue?vue&type=script&lang=js"
import style0 from "./EditItemDialogImage.vue?vue&type=style&index=0&id=4a07c2d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports